import { PROJECTS_URL, PROJECT_URL } from "@/config/apiEndpoints";
import apiRequest from "@/utils/apiRequest";
import convertDate from "@/utils/convertDateToStandard";

export const state = {
  projects: null,
  members: [],
  roles: [],
  selectedProjectDetails: null,
  loading: false,
};
export const getters = {
  projects: (state) => state.projects,
  members: (state) => state.members,
  roles: (state) => state.roles,
  loading: (state) => state.loading,
  selectedProjectDetails: (state) => state.selectedProjectDetails,
};

export const mutations = {
  STORE_MEMBERS(state) {
    state.members = [];
    state.loading = true;
  },
  STORE_MEMBERS_SUCCESS(state, members) {
    state.members = [...members];
    state.loading = false;
  },
  STORE_MEMBERS_FAILED(state) {
    state.members = [];
    state.loading = false;
  },
  STORE_PROJECT(state) {
    state.loading = true;
    state.selectedProjectDetails = null;
  },
  STORE_PROJECT_SUCCESS(state, project) {
    state.loading = false;
    state.selectedProjectDetails = { ...project };
  },
  STORE_PROJECT_FAILURE(state) {
    state.loading = false;
    state.selectedProjectDetails = null;
  },
  STORE_PROJECTS(state) {
    state.projects = null;
    state.loading = true;
  },
  STORE_PROJECTS_SUCCESS(state, projects) {
    state.projects = [...projects];
    state.loading = false;
  },
  STORE_PROJECTS_FAILURE(state) {
    state.projects = null;
    state.loading = false;
  },
  STORE_ROLES(state) {
    state.roles = [];
    state.loading = true;
  },
  STORE_ROLES_SUCCESS(state, roles) {
    state.roles = [...roles];
    state.loading = false;
  },
  STORE_ROLES_FAILED(state) {
    state.roles = [];
    state.loading = false;
  },
  DELETE_MEMBER(state, memberId) {
    state.members = state.members.filter((x) => x.member_id !== memberId);
  },
};

export const actions = {
  fetchProjects({ commit }, orgId) {
    if (!orgId) return;
    commit("STORE_PROJECTS");
    return new Promise((resolve, reject) => {
      apiRequest({
        url: PROJECTS_URL,
        method: "GET",
        params: { type: "o", org_id: orgId },
      })
        .then((res) => {
          const serializedResponse = res.data.map((x) => {
            return {
              ...x,
              created_at: convertDate(new Date(x.created_at)),
              last_modified_at: convertDate(new Date(x.last_modified_at)),
            };
          });
          commit("STORE_PROJECTS_SUCCESS", serializedResponse);
          resolve(serializedResponse);
        })
        .catch((err) => {
          commit("STORE_PROJECTS_FAILURE");
          reject(err);
        });
    });
  },
  fetchProject({ commit }, params) {
    return new Promise((resolve, reject) => {
      commit("STORE_PROJECT");
      apiRequest({
        url: PROJECT_URL,
        method: "GET",
        params: params,
      })
        .then((res) => {
          commit("STORE_PROJECT_SUCCESS", res.data);
          resolve(res);
        })
        .catch((err) => {
          commit("STORE_PROJECT_FAILURE");
          reject(err);
        });
    });
  },
  selectProject({ commit }, project) {
    commit("STORE_PROJECT");
    commit("STORE_PROJECT_SUCCESS", project);
  },
  //   fetchRoles({ commit }) {
  //     return new Promise((resolve, reject) => {
  //       apiRequest({
  //         url: GET_ROLES_URL,
  //         method: "GET",
  //       })
  //         .then((response) => {
  //           const roles = response.data.map((x) => {
  //             return {
  //               id: x.Id,
  //               name: convertToTitleCase(x.Name),
  //             };
  //           });
  //           commit("STORE_ROLES_SUCCESS", roles);
  //           resolve(roles);
  //         })
  //         .catch((err) => {
  //           reject(err);
  //         });
  //     });
  //   },
};

// function convertToTitleCase(str) {
//   return str[0].toUpperCase() + str.slice(1);
// }
